import { useEffect, useState } from "react";
import { commonService } from "../../../services/common.service";
import { MaintenanceTimeResponse } from "../../../models/Response/maintenanceTimeResponse";
import { useNavigate } from "react-router-dom";

type TimeLeft = {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
};

export default function Maintenance() {
    const [toDate, setToDate] = useState<string>("");
    const [remark, setRemark] = useState<string>("");
    const [timeLeft, setTimeLeft] = useState<TimeLeft | null>(null);

    const navigate = useNavigate();

    useEffect(() => {
        const fetchCommonConfig = async () => {
            const response = await commonService.fetchCommonConfig();

            if (!response.isSuccess) {
                const data = JSON.parse(response.message) as MaintenanceTimeResponse;

                if (data) {
                    setToDate(data.ToDate);
                    setRemark(data.Remark ?? "");
                }
            }
        };

        fetchCommonConfig();
    }, []);

    useEffect(() => {
        if (!toDate) return;

        const calculateTimeLeft = (): TimeLeft => {
            const now = new Date().getTime();
            const target = new Date(toDate).getTime();
            const diff = target - now;

            if (diff <= 0) {
                return { days: 0, hours: 0, minutes: 0, seconds: 0 };
            }

            return {
                days: Math.floor(diff / (1000 * 60 * 60 * 24)),
                hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((diff / (1000 * 60)) % 60),
                seconds: Math.floor((diff / 1000) % 60),
            };
        };

        setTimeLeft(calculateTimeLeft());

        const interval = setInterval(() => {
            const updated = calculateTimeLeft();
            setTimeLeft(updated);

            if (
                updated.days === 0 &&
                updated.hours === 0 &&
                updated.minutes === 0 &&
                updated.seconds === 0
            ) {
                clearInterval(interval);
                navigate("/");
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [toDate, navigate]);

    return (
        <div className="flex flex-col items-center justify-center h-screen text-center">
            <img
                src="/images/logo.svg"
                alt="logo"
                className="size-32 mb-4 cursor-pointer"
                onClick={() => navigate("/")}
            />

            <h1 className="text-4xl font-bold mb-4">
                Site Under Maintenance
            </h1>

            {remark && (
                <h2 className="mt-4 text-2xl font-semibold text-gray-300">
                    {remark}
                </h2>
            )}

            {timeLeft && (
                <p className="text-xl mt-4">
                    {timeLeft.days} days, {timeLeft.hours} hours,{" "}
                    {timeLeft.minutes} minutes, {timeLeft.seconds} seconds
                </p>
            )}
        </div>
    );
}